import Config from 'react-native-config';
import { Coordinate } from 'modules/types/common';
import { OptionType } from './search/types';

export const PROVIDER_SEARCH_CLIENT = 'provider';

export const defaultCoordinates: Coordinate = {
  latitude: 40.768047,
  longitude: -111.888381
} as const;

export const searchLimit = parseInt(Config.PROVIDER_RESULT_PAGE_SIZE, 10);
export const defaultLocationText = 'Salt Lake City';
export const fetchingText = 'Fetching results . . .';
export const searchErrorText =
  "We're sorry, there was an issue fetching providers. Please try again.";
export const noOptionsText = 'No results found. Please adjust your search and try again.';
export const noOptionsTextSelectHealth =
  'No results found. Please adjust your search or try some of the links below.';
export const searchPlaceholder = 'Provider, Clinic, Specialty';
export const currentLocation = 'Current Location';
export const termsNotFound = 'Unable to locate Terms & Conditions document';
export const versionNotFound = 'error retrieving version';

export const selectHealthInsuranceLinks = [
  {
    text: 'Delta Dental (Idaho Dental Advantage)',
    link: Config.SH_LINK_PROVIDER_DELTA_DENTAL_IDAHO
  },
  {
    text: 'Delta Dental (Nevada Dental Advantage)',
    link: Config.SH_LINK_PROVIDER_DELTA_DENTAL_NEVADA
  },
  { text: 'EyeMed', link: Config.SH_LINK_PROVIDER_EYEMED },
  { text: 'Multiplan', link: Config.SH_LINK_PROVIDER_MULTI_PLAN },
  { text: 'PCHS', link: Config.SH_LINK_PROVIDER_PCHS },
  { text: 'Beech Street', link: Config.SH_LINK_PROVIDER_BEECH_STREET },
  { text: 'First Choice', link: Config.SH_LINK_PROVIDER_FIRST_CHOICE }
];

export const sortBy: Record<string, OptionType> = {
  BEST_MATCH: {
    label: 'Top Match',
    value: 'bestMatch'
  },
  PROXIMITY: {
    label: 'Proximity',
    value: 'proximity'
  },
  RATING: {
    label: 'Highest Rating',
    value: 'rating'
  },
  LAST_NAME: {
    label: 'Last Name',
    value: 'lastName'
  },
  ACCEPTS_NEW_PATIENTS: {
    label: 'Accepts New Patients',
    value: 'acceptingNewPatients'
  }
} as const;

export const sortOptions: Record<string, OptionType[]> = {
  ACCEPTED_TC: [
    sortBy.BEST_MATCH,
    sortBy.PROXIMITY,
    sortBy.RATING,
    sortBy.LAST_NAME,
    sortBy.ACCEPTS_NEW_PATIENTS
  ],
  DECLINED_TC: [sortBy.LAST_NAME, sortBy.PROXIMITY, sortBy.RATING]
};
